"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceALl = void 0;
var replaceALl = function (originalString, searchValue, newStr) {
    // If a regex pattern
    if (Object.prototype.toString.call(searchValue).toLowerCase() === '[object regexp]') {
        return originalString.replace(searchValue, newStr);
    }
    // If a string
    return originalString.replace(new RegExp(searchValue, 'g'), newStr);
};
exports.replaceALl = replaceALl;
